import { render } from "./news-and-media.vue?vue&type=template&id=33ca1e96"
import script from "./news-and-media.vue?vue&type=script&lang=js"
export * from "./news-and-media.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__